import { Box,Button,Text, TextInput } from 'grommet';
import { Ascend, Descend, Search, Unsorted } from 'grommet-icons';
import React from 'react'
import sortArray from '../functions/sortArray';
import BookListUnit from './BookListUnit';
// import {BsSortAlphaDown,
// BsSortAlphaUp,
// BsSortNumericDown,
// BsSortNumericUp} from "react-icons/bs"

const BookList = (props:any) => {

  let Books = props.booklist
  let sOption = props.sortoption
  const [bookSorted, setBookSorted] = React.useState<any>([])
  const [sortOption, setSortOption] = React.useState("title")
  const [sortDirection, setSortDirection] = React.useState(1)

  React.useEffect(()=>{
    if(sOption!==null){
      setSortOption(sOption)
    }
    if(Books.length>1){
        let books_sorted = sortArray({
            listx: Books,
            soption: sortOption,
            dir: sortDirection,
        });
        setBookSorted(books_sorted);
    } else {
        setBookSorted(Books)
    }
  },[])


  return (
    <Box direction="column" align="center" justify="start" width="full">
      <Box
        width="full"
        align="center"
        justify="start"
        overflow={"scroll"}
        direction="column"
      >
        {bookSorted.map((b: any) => (
          <Box key={b.book_id} width="full" margin="1px"
            alignContent="stretch" fill={true} overflow={"scroll"}
            pad={{ horizontal: "30px" }}
            style={{ minHeight: "50px" }}>
            <BookListUnit bookinfo={b} />
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default BookList;